"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = require("../../Input");

require("./CheckboxModalFooter.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxModalFooter = function CheckboxModalFooter(_ref) {
  var _ref$checkboxCopy = _ref.checkboxCopy,
      checkboxCopy = _ref$checkboxCopy === void 0 ? '' : _ref$checkboxCopy,
      _ref$checkboxInputMod = _ref.checkboxInputModel,
      checkboxInputModel = _ref$checkboxInputMod === void 0 ? 'forms.tosModal.isAccepted' : _ref$checkboxInputMod,
      _ref$submitBtnAction = _ref.submitBtnAction,
      submitBtnAction = _ref$submitBtnAction === void 0 ? function () {} : _ref$submitBtnAction,
      _ref$submitBtnDisable = _ref.submitBtnDisabled,
      submitBtnDisabled = _ref$submitBtnDisable === void 0 ? true : _ref$submitBtnDisable,
      _ref$submitBtnText = _ref.submitBtnText,
      submitBtnText = _ref$submitBtnText === void 0 ? 'Close' : _ref$submitBtnText;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox-modal-footer"
  }, /*#__PURE__*/_react.default.createElement(_Input.InputGroup, {
    inline: true,
    type: "checkbox",
    customClass: "tos-modal-checkbox",
    labelText: checkboxCopy,
    model: checkboxInputModel
  }), /*#__PURE__*/_react.default.createElement("button", {
    disabled: submitBtnDisabled,
    onClick: submitBtnAction
  }, submitBtnText));
};

var bool = _propTypes.default.bool,
    func = _propTypes.default.func,
    string = _propTypes.default.string;
CheckboxModalFooter.propTypes = {
  checkboxCopy: string,
  checkboxInputModel: string,
  submitBtnAction: func,
  submitBtnDisabled: bool,
  submitBtnText: string
};
var _default = CheckboxModalFooter;
exports.default = _default;